import PropTypes from "prop-types";

const FrameComponent = ({ className = "" }) => {
  return (
    <section
      className={`flex flex-col items-start gap-[101px] min-w-[564px] max-w-full text-left text-[40px] text-[#fff] font-[Manrope] lg:flex-1 mq750:gap-[50px] mq1050:min-w-full mq450:gap-[25px] ${className}`}
    >
      <div className="self-stretch flex items-start justify-end pt-0 px-0 pb-6 text-center font-['Great_Vibes']">
        <div className="flex flex-col items-start gap-1.5">
          <div className="self-stretch rounded-[10px] bg-[#1e1e1e] flex items-start pt-2.5 pb-[23px] pl-7 pr-[21px]">
            <div className="h-[104px] w-[244px] relative rounded-[10px] bg-[#1e1e1e] hidden shrink-0" />
            <div className="flex-1 relative z-[1] shrink-0 mq1050:text-[32px] mq450:text-2xl">
              <span>Insta</span>
              <span className="text-[64px] font-black font-['Kumbh_Sans']">
                ED
              </span>
            </div>
          </div>
          <div className="flex items-start py-0 pl-[7px] pr-0.5 text-left text-2xl text-[#000] font-['Maven_Pro']">
            <h3 className="m-0 relative text-[length:inherit] font-normal font-[inherit] mq450:text-[19px]">
              Online Tuitions | 6-12
            </h3>
          </div>
        </div>
      </div>
      <div className="flex items-start relative isolate max-w-full text-4xl text-schemes-primary">
        <div className="h-[87px] relative leading-[87px] font-extrabold inline-block shrink-0 mq1050:text-[29px] mq450:text-[22px]">
          <span>The perfect</span>
          <span className="text-5xl">{` `}</span>
          <span className="text-[64px]">Alternate</span>
        </div>
        <div className="h-[87px] absolute !!m-[0 important] right-[-43px] bottom-[-70px] leading-[87px] font-extrabold inline-block z-[1] shrink-0 mq1050:text-[29px] mq450:text-[22px]">
          <span>to</span>
          <span className="text-[40px]">{` `}</span>
          <span className="text-[64px]">‘Offline’ Tuition.</span>
        </div>
      </div>
      <div className="flex items-start pt-0 px-0 pb-[15px] text-[32px] text-[#000]">
        <h1 className="m-0 relative text-[length:inherit] font-normal font-[inherit] mq1050:text-[26px] mq450:text-[19px]">
          The online class that finally feels right
        </h1>
      </div>
      <div className="w-[492px] flex items-start justify-center py-0 px-5 box-border max-w-full">
        <div className="flex flex-col items-end gap-11">
          <img
            className="self-stretch h-[25px] relative max-w-full overflow-hidden shrink-0"
            loading="lazy"
            alt=""
            src="./Group-91.svg"
          />
          <div className="flex items-start justify-end py-0 pl-6 pr-[23px]">
            <button className="cursor-pointer border-[#948d8d] border-solid border-[1px] pt-3.5 pb-4 pl-[29px] pr-6 bg-[#fff] h-[67px] rounded-[5px] box-border flex items-start hover:bg-[#e6e6e6] hover:border-[#7a7373] hover:border-solid hover:hover:border-[1px] hover:box-border">
              <div className="h-[67px] w-[183px] relative rounded-[5px] bg-[#fff] border-[#948d8d] border-solid border-[1px] box-border hidden shrink-0" />
              <div className="relative text-2xl font-[Manrope] text-[#000] text-left z-[1] shrink-0">
                Get Started
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

FrameComponent.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent;
